import { render, staticRenderFns } from "./BotaoRastreabilidadeSucursales.vue?vue&type=template&id=49277466&lang=pug"
import script from "./BotaoRastreabilidadeSucursales.vue?vue&type=script&lang=js"
export * from "./BotaoRastreabilidadeSucursales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports